export const titleText = "Sacrifice2Mint Ceremony"
export const subtitleText = "Welcome to the";